function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "F5325B08-E474-4498-AF69-032A8C837A5E@3x");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.44624256
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Set",
  transform: "translate(-186.000000, -117.000000)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Camera_1992172",
  transform: "translate(186.000000, 117.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.32,11.9318182 C16.32,14.3266291 14.3702655,16.2272727 12,16.2272727 C9.59150442,16.2272727 7.68,14.2886163 7.68,11.9318182 C7.68,9.57502011 9.59150442,7.63636364 12,7.63636364 C14.4084956,7.63636364 16.32,9.53700724 16.32,11.9318182 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.3733333,3.05454545 L17.3333333,3.05454545 L17.2266667,2.15454545 C17.0666667,0.927272727 16.0533333,0 14.8266667,0 L9.17333333,0 C7.97333333,0 6.93333333,0.927272727 6.77333333,2.15454545 L6.66666667,3.05454545 L3.62666667,3.05454545 C1.62666667,3.05454545 0,4.71818182 0,6.76363636 L0,17.2909091 C0,19.3363636 1.62666667,21 3.62666667,21 L20.3733333,21 C22.3733333,21 24,19.3363636 24,17.2909091 L24,6.76363636 C24,4.71818182 22.3733333,3.05454545 20.3733333,3.05454545 Z M12,17.4818182 C9.04,17.4818182 6.66666667,15.0272727 6.66666667,12.0272727 C6.66666667,9.02727273 9.06666667,6.57272727 12,6.57272727 C14.96,6.57272727 17.3333333,9.02727273 17.3333333,12.0272727 C17.3333333,15.0272727 14.96,17.4818182 12,17.4818182 Z M18.0533333,6.43636364 C17.6,6.43636364 17.2533333,6.08181818 17.2533333,5.61818182 C17.2533333,5.15454545 17.6,4.8 18.0533333,4.8 C18.5066667,4.8 18.8533333,5.15454545 18.8533333,5.61818182 C18.8533333,6.08181818 18.5066667,6.43636364 18.0533333,6.43636364 Z",
  id: "Shape",
  fillRule: "nonzero"
}))));

var SvgCamera = function SvgCamera(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "21px",
    viewBox: "0 0 24 21",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera.78543e4e.svg";
export { ForwardRef as ReactComponent };